var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category mb-5"},[_c('h3',[_c('span',[_vm._v(_vm._s(_vm.category.title))])]),_c('DocumentList',{attrs:{"documents":_vm.documents,"cols":4,"show-category":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }